/** Default desktop carousel columns (cart promos, suggestions, etc.). */
export const DEFAULT_DESKTOP_CAROUSEL_SLOTS = 6;

/** Shop-page highlight: fewer columns → larger product images without 50% blowout. */
export const SHOP_PAGE_DESKTOP_CAROUSEL_SLOTS = 4;

export function desktopCarouselSlotCount(
  displayContext: string,
  override?: number | null,
): number {
  if (override != null && override > 0) {
    return override;
  }
  if (displayContext === 'shop_page') {
    return SHOP_PAGE_DESKTOP_CAROUSEL_SLOTS;
  }
  return DEFAULT_DESKTOP_CAROUSEL_SLOTS;
}
